"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58266],{

/***/ 94594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_switch; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(21770);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(15105);
;// CONCATENATED MODULE: ./node_modules/rc-switch/es/index.js







var Switch = react.forwardRef(function (_ref, ref) {
  var _classNames;

  var _ref$prefixCls = _ref.prefixCls,
      prefixCls = _ref$prefixCls === void 0 ? 'rc-switch' : _ref$prefixCls,
      className = _ref.className,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      loadingIcon = _ref.loadingIcon,
      checkedChildren = _ref.checkedChildren,
      unCheckedChildren = _ref.unCheckedChildren,
      onClick = _ref.onClick,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"]);

  var _useMergedState = (0,useMergedState/* default */.Z)(false, {
    value: checked,
    defaultValue: defaultChecked
  }),
      _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
      innerChecked = _useMergedState2[0],
      setInnerChecked = _useMergedState2[1];

  function triggerChange(newChecked, event) {
    var mergedChecked = innerChecked;

    if (!disabled) {
      mergedChecked = newChecked;
      setInnerChecked(mergedChecked);
      onChange === null || onChange === void 0 ? void 0 : onChange(mergedChecked, event);
    }

    return mergedChecked;
  }

  function onInternalKeyDown(e) {
    if (e.which === KeyCode/* default.LEFT */.Z.LEFT) {
      triggerChange(false, e);
    } else if (e.which === KeyCode/* default.RIGHT */.Z.RIGHT) {
      triggerChange(true, e);
    }

    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  }

  function onInternalClick(e) {
    var ret = triggerChange(!innerChecked, e); // [Legacy] trigger onClick with value

    onClick === null || onClick === void 0 ? void 0 : onClick(ret, e);
  }

  var switchClassName = classnames_default()(prefixCls, className, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-checked"), innerChecked), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
  return react.createElement("button", Object.assign({}, restProps, {
    type: "button",
    role: "switch",
    "aria-checked": innerChecked,
    disabled: disabled,
    className: switchClassName,
    ref: ref,
    onKeyDown: onInternalKeyDown,
    onClick: onInternalClick
  }), loadingIcon, react.createElement("span", {
    className: "".concat(prefixCls, "-inner")
  }, innerChecked ? checkedChildren : unCheckedChildren));
});
Switch.displayName = 'Switch';
/* harmony default export */ var es = (Switch);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50888);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/wave.js + 1 modules
var wave = __webpack_require__(68349);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js + 1 modules
var context = __webpack_require__(59844);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/SizeContext.js
var SizeContext = __webpack_require__(97647);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/devWarning.js
var devWarning = __webpack_require__(21687);
;// CONCATENATED MODULE: ./node_modules/antd/es/switch/index.js



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









var switch_Switch = /*#__PURE__*/react.forwardRef(function (_a, ref) {
  var _classNames;

  var customizePrefixCls = _a.prefixCls,
      customizeSize = _a.size,
      loading = _a.loading,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      disabled = _a.disabled,
      props = __rest(_a, ["prefixCls", "size", "loading", "className", "disabled"]);

  (0,devWarning/* default */.Z)('checked' in props || !('value' in props), 'Switch', '`value` is not a valid prop, do you mean `checked`?');

  var _React$useContext = react.useContext(context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var size = react.useContext(SizeContext/* default */.Z);
  var prefixCls = getPrefixCls('switch', customizePrefixCls);
  var loadingIcon = /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-handle")
  }, loading && /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, {
    className: "".concat(prefixCls, "-loading-icon")
  }));
  var classes = classnames_default()((_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-small"), (customizeSize || size) === 'small'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-loading"), loading), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
  return /*#__PURE__*/react.createElement(wave/* default */.Z, {
    insertExtraNode: true
  }, /*#__PURE__*/react.createElement(es, (0,esm_extends/* default */.Z)({}, props, {
    prefixCls: prefixCls,
    className: classes,
    disabled: disabled || loading,
    ref: ref,
    loadingIcon: loadingIcon
  })));
});
switch_Switch.__ANT_SWITCH = true;
switch_Switch.displayName = 'Switch';
/* harmony default export */ var es_switch = (switch_Switch);

/***/ }),

/***/ 66988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27691);
/* eslint-disable no-undef */ 


var CORP_ACTION_IMG = "/icon/corp_action_event_icon.svg";
function CorpActionTag(param) {
    var corpAction = param.corpAction, _className = param.className, className = _className === void 0 ? "" : _className, _isCorpActionBadges = param.isCorpActionBadges, isCorpActionBadges = _isCorpActionBadges === void 0 ? false : _isCorpActionBadges;
    var icon = (corpAction === null || corpAction === void 0 ? void 0 : corpAction.icon) || CORP_ACTION_IMG;
    var text = (corpAction === null || corpAction === void 0 ? void 0 : corpAction.text) || "Corporate Action";
    return(// @ts-expect-error
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .TagWrapper */ .nf, {
        className: className,
        isCorpActionBadges: isCorpActionBadges,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            alt: text,
            src: icon
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (CorpActionTag);


/***/ }),

/***/ 27691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CC": function() { return /* binding */ IconArrow; },
/* harmony export */   "iG": function() { return /* binding */ BarWrapper; },
/* harmony export */   "nf": function() { return /* binding */ TagWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: rgba(147,67,200,.08);\n  cursor: pointer;\n  padding: 0px 18px;\n\n  @media ",
        " {\n    padding: 0 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 16px;\n      width: 16px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 20px;\n      width: 20px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-right: 0;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 12px;\n  margin: 0 4px;\n  width: 12px;\n\n  & > img {\n    width: 100%;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ';\n  font-size: 12px;\n\n  &:before {\n    content: "\\e968";\n  }\n\n  &:hover {\n    color: ',
        ";\n  }\n"
    ], [
        "\n  color: ",
        ';\n  font-size: 12px;\n\n  &:before {\n    content: "\\\\e968";\n  }\n\n  &:hover {\n    color: ',
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var BarWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    align: "center",
    height: "38px",
    justify: "space-between",
    width: "100%"
}).withConfig({
    componentId: "sc-349dc1f5-0"
})(_templateObject(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet);
var TagWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs(function(props) {
    return {
        align: "center",
        justify: "center"
    };
}).withConfig({
    componentId: "sc-349dc1f5-1"
})(_templateObject4(), // @ts-expect-error
function(param) {
    var size = param.size;
    return size === "medium" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1());
}, // @ts-expect-error
function(param) {
    var size = param.size;
    return size === "large" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2());
}, // @ts-expect-error
function(param) {
    var isCorpActionBadges = param.isCorpActionBadges;
    return isCorpActionBadges && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject3());
});
var ICON_ARROW_COLOR = "#9343c8";
var IconArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-349dc1f5-2"
})(_templateObject5(), ICON_ARROW_COLOR, ICON_ARROW_COLOR);



/***/ }),

/***/ 39767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useLivePrice; }
/* harmony export */ });
/* harmony import */ var _useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65131);
/* harmony import */ var _useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35320);


var useLivePrice = function(symbols, stateKey, actionKey, onMessage) {
    (0,_useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceSender */ .O)(stateKey, symbols);
    (0,_useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_0__/* .useLivePriceReceiver */ .V)(symbols, actionKey, onMessage);
};


/***/ }),

/***/ 30682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ GlobalModalType; }
/* harmony export */ });
var GlobalModalType;
(function(GlobalModalType) {
    GlobalModalType["FastOrder"] = "fastOrder";
    GlobalModalType["ChatLimit"] = "chatLimit";
})(GlobalModalType || (GlobalModalType = {}));


/***/ }),

/***/ 92292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Notation_Content; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/Notation/styled.ts + 1 modules
var styled = __webpack_require__(69836);
;// CONCATENATED MODULE: ./src/global/Notation/NotationListItem.tsx



function NotationListItem(param) {
    var code = param.code, desc = param.desc, _isUma = param.isUma, isUma = _isUma === void 0 ? false : _isUma;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        justify: "space-between",
        mb: "10px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "flex-end",
                width: "44px",
                mr: "12px",
                pb: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationTag */.GU, {
                    isUma: isUma,
                    children: code
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Description */.dk, {
                children: desc
            })
        ]
    }));
}
/* harmony default export */ var Notation_NotationListItem = (NotationListItem);

;// CONCATENATED MODULE: ./src/global/Notation/Content.tsx








function Content(_param) {
    var notation = _param.notation, symbol = _param.symbol, name = _param.name, notationTag = _param.notationTag, props = (0,_object_without_properties/* default */.Z)(_param, [
        "notation",
        "symbol",
        "name",
        "notationTag"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Container */.W2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        direction: "column",
        align: "center"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "h1",
                        size: "20px",
                        height: "24px",
                        align: "center",
                        family: "bold",
                        children: symbol
                    }),
                    notationTag
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "p",
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                py: "14px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "p",
                    align: "center",
                    children: "Perusahaan memiliki Notasi Khusus sebagai berikut:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationList */.HC, {
                direction: "column",
                align: "center",
                justify: "space-evenly",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: notation.map(function(param) {
                        var notation_code = param.notation_code, notation_desc = param.notation_desc, code = param.code, desc = param.desc;
                        return code && desc || notation_code && notation_desc ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation_NotationListItem, {
                            code: notation_code || code,
                            desc: notation_desc || desc
                        }, "notation-".concat(code)) : null;
                    })
                })
            })
        ]
    }));
}
/* harmony default export */ var Notation_Content = (Content);


/***/ }),

/***/ 63631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10808);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var _deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48308);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var global_TradingModal_hooks_useIsUserSyariah__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66940);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69836);







var PopoverNotation = function(param) {
    var company = param.company;
    var dayTradeInfo = company.day_trade_info, tradingLimitInfo = company.trading_limit_info;
    var ref = dayTradeInfo || {}, multiplier = ref.multiplier, isShowMultiplier = ref.is_show_multiplier;
    var isUserSyariah = (0,global_TradingModal_hooks_useIsUserSyariah__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var showMultiplier = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return [
            parseInt(multiplier, 10) > 1,
            isShowMultiplier,
            !isUserSyariah
        ].every(Boolean);
    }, [
        multiplier,
        isShowMultiplier,
        isUserSyariah
    ]);
    var showTradingLimit = tradingLimitInfo === null || tradingLimitInfo === void 0 ? void 0 : tradingLimitInfo.is_trading_limit;
    if (!showMultiplier && !showTradingLimit) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .PopoverBadgeContainer */ .LA, {
            children: [
                showMultiplier && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                            style: {
                                marginBottom: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    weight: "bold",
                                    children: "Day Trade"
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .MultiplierChip */ .L$, {
                                    className: "multiplier-chip",
                                    style: {
                                        marginLeft: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            src: "/images/day-trade/lightning-filled-company.svg",
                                            alt: "",
                                            height: "10",
                                            width: "10"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                            size: "12px",
                                            color: "#8277F8",
                                            weight: "bold",
                                            children: "".concat(multiplier, "x")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            height: "19px",
                            children: [
                                "Saham ini bisa dibeli dengan Day Trade dengan nilai hingga",
                                " ",
                                multiplier,
                                "x Trading Balance kamu."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                    ]
                }),
                showTradingLimit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                            style: {
                                marginBottom: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    weight: "bold",
                                    children: "Trading Limit"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .TradingLimitBadge */ .o7, {
                                    style: {
                                        marginLeft: 4
                                    },
                                    children: "TL"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            height: "19px",
                            children: [
                                "Saham ini bisa dibeli dengan Trading Limit dan dapat dijadikan jaminan dengan haircut ",
                                tradingLimitInfo === null || tradingLimitInfo === void 0 ? void 0 : tradingLimitInfo.haircut_percentage,
                                "."
                            ]
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .NotationPopoverContainer */ .MC, {
            children: [
                showMultiplier && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .MultiplierContainer */ .cF, {
                    style: {
                        cursor: "default"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .MultiplierChip */ .L$, {
                        className: "multiplier-chip",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                src: "/images/day-trade/lightning-filled-company.svg",
                                alt: "",
                                height: "10",
                                width: "10"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                size: "12px",
                                color: "#8277F8",
                                weight: "bold",
                                children: "".concat(multiplier, "x")
                            })
                        ]
                    })
                }),
                showTradingLimit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .TradingLimitBadge */ .o7, {
                    style: {
                        cursor: "default",
                        marginLeft: !showMultiplier ? 8 : 0
                    },
                    children: "TL"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PopoverNotation);


/***/ }),

/***/ 15068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16368);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92292);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69836);






var INDICATOR_ICON_URL = "/icon/ic_indicator.svg";
var UMA_ICON_URL = "/icon/ic_uma.svg";
var X_ICON_URL = "/icon/ic_x.svg";
var NOTATION_TYPE = {
    INDICATOR: "indicator",
    UMA: "uma",
    X: "x"
};
var INDICATOR_ALT_TEXT = "indikator notasi khusus";
function Notation(param) {
    var symbol = param.symbol, notation = param.notation, uma = param.uma, isModal = param.isModal, name = param.name, _isPopover = param.isPopover, isPopover = _isPopover === void 0 ? true : _isPopover, _type = param.type, type = _type === void 0 ? NOTATION_TYPE.INDICATOR : _type, _isNotationBadges = param.isNotationBadges, isNotationBadges = _isNotationBadges === void 0 ? false : _isNotationBadges, _className = param.className, className = _className === void 0 ? "" : _className, _placement = param.placement, placement = _placement === void 0 ? "top" : _placement;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), visible = ref[0], setVisible = ref[1];
    var onCloseModal = function() {
        return setVisible(false);
    };
    var isUma = type === NOTATION_TYPE.UMA && !!uma;
    var isX = type === NOTATION_TYPE.X;
    var renderTag = function(param) {
        var _type = param.// eslint-disable-next-line @typescript-eslint/no-shadow
        type, type = _type === void 0 ? NOTATION_TYPE.INDICATOR : _type, _isNotationBadges = param.// eslint-disable-next-line @typescript-eslint/no-shadow
        isNotationBadges, isNotationBadges = _isNotationBadges === void 0 ? false : _isNotationBadges, _src = param.src, src = _src === void 0 ? INDICATOR_ICON_URL : _src, _alt = param.alt, alt = _alt === void 0 ? INDICATOR_ALT_TEXT : _alt;
        return(// @ts-expect-error
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .NotationTag */ .GU, {
            type: type,
            isSmall: true,
            isNotationBadges: isNotationBadges,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                alt: alt,
                src: src
            })
        }));
    };
    var renderNotation = function() {
        if (isUma) {
            return renderTag({
                type: NOTATION_TYPE.UMA,
                src: UMA_ICON_URL,
                alt: "".concat(INDICATOR_ALT_TEXT, " uma"),
                className: "",
                isNotationBadges: isNotationBadges
            });
        }
        if (isX) {
            return renderTag({
                type: NOTATION_TYPE.X,
                src: X_ICON_URL,
                alt: "".concat(INDICATOR_ALT_TEXT, " x"),
                className: "",
                isNotationBadges: isNotationBadges
            });
        }
        return renderTag({
            type: type,
            isNotationBadges: isNotationBadges
        });
    };
    var renderContent = function() {
        var isFullSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Content__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            symbol: symbol,
            uma: uma,
            notation: notation,
            name: name,
            notationTag: renderTag({
                type: NOTATION_TYPE.INDICATOR,
                isNotationBadges: true
            }),
            isFullSize: isFullSize
        });
    };
    if (isModal) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: function() {
                        return setVisible(true);
                    },
                    "aria-hidden": "true",
                    children: renderTag({
                        type: NOTATION_TYPE.INDICATOR,
                        isNotationBadges: true
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    visible: visible,
                    onCancel: onCloseModal,
                    title: null,
                    centered: true,
                    width: "500px",
                    children: renderContent(true)
                })
            ]
        });
    }
    if (!isPopover) {
        return renderNotation();
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .PopoverIndicator */ .H9, {
        className: className,
        content: renderContent(),
        // @ts-expect-error
        placement: placement,
        children: renderNotation()
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Notation);


/***/ }),

/***/ 39337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_TradingModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/hooks/useGetPortfolioData.ts
var useGetPortfolioData = __webpack_require__(47002);
// EXTERNAL MODULE: ./src/lib/analytics/virtualTrading.ts
var virtualTrading = __webpack_require__(29351);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/global/VirtualTrading/api/portfolio.ts + 1 modules
var portfolio = __webpack_require__(80943);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/stores/usePortfolioStore.ts






var initialState = {
    portfolio: {
        available_lot: 0,
        balance_lot: 0,
        price: {
            order: 0,
            average: 0,
            market: 0
        }
    },
    portfolioList: {
        trading_balance: 0,
        amount: {
            invested: 0,
            allocated: 0,
            credit_limit: 0
        },
        result: [],
        profit_loss: {
            unrealized: 0,
            realized: 0,
            total: 0
        },
        equity: 0,
        gain: 0
    }
};
var usePortfolioStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        loadPortfolioDetail: function loadPortfolioDetail(symbol) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, axiosData, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,portfolio/* getPortfolioDetail */.P)(symbol);
                        case 3:
                            ref = _ctx.sent;
                            axiosData = ref.data;
                            data = axiosData.data;
                            set({
                                portfolio: data
                            });
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }))();
        },
        loadPortfolioList: function loadPortfolioList() {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, axiosData, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,portfolio/* getPortfolioList */.g)();
                        case 3:
                            ref = _ctx.sent;
                            axiosData = ref.data;
                            data = axiosData.data;
                            set({
                                portfolioList: data
                            });
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }))();
        }
    });
});
/* harmony default export */ var stores_usePortfolioStore = (usePortfolioStore);

// EXTERNAL MODULE: ./src/global/TradingModal/styled.ts
var styled = __webpack_require__(76805);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/lib/stores/tradingOperation.ts + 1 modules
var tradingOperation = __webpack_require__(31532);
// EXTERNAL MODULE: ./src/global/VirtualTrading/stores/useVirtualOrderStore.ts
var useVirtualOrderStore = __webpack_require__(72965);
// EXTERNAL MODULE: ./src/global/VirtualTrading/utils/formula.ts
var formula = __webpack_require__(41150);
// EXTERNAL MODULE: ./src/global/Securities/components/Slider/index.tsx + 1 modules
var Slider = __webpack_require__(37212);
// EXTERNAL MODULE: ./src/global/TradingModal/components/FormItem.tsx
var FormItem = __webpack_require__(27892);
// EXTERNAL MODULE: ./src/global/TradingModal/utils/generateStepPrice.ts
var generateStepPrice = __webpack_require__(97103);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
;// CONCATENATED MODULE: ./src/global/TradingModal/VirtualTradingModal/store.ts



var store_initialState = {
    price: 0,
    shares: 0,
    stockCode: "",
    latestPortfolio: {
        isLoading: false,
        message: "",
        data: {
            available_lot: 0,
            price_average: 0
        },
        error: ""
    }
};
var virtualTradingStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, store_initialState), {
        setPrice: function(payload) {
            set({
                price: payload
            });
        },
        setShares: function(payload) {
            set({
                shares: payload
            });
        },
        setStockCode: function(payload) {
            set({
                stockCode: payload
            });
        },
        resetOrderData: function() {
            set(store_initialState);
        }
    });
});
/* harmony default export */ var store = (virtualTradingStore);

// EXTERNAL MODULE: ./src/global/TradingModal/components/NumberInput.tsx
var NumberInput = __webpack_require__(93951);
;// CONCATENATED MODULE: ./src/global/TradingModal/VirtualTradingModal/FormSell.tsx






















function FormSell(param) {
    var orderType = param.orderType, _orderid = param.orderid, orderid = _orderid === void 0 ? undefined : _orderid, orderedLot = param.orderedLot, orderedPrice = param.orderedPrice, closeModal = param.closeModal;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), isButtonLoading = ref1[0], setIsButtonLoading = ref1[1];
    var ref2 = stores_usePortfolioStore(), _portfolio = ref2.portfolio, _price = _portfolio.price, priceAverage = _price.average, available_lot = _portfolio.available_lot;
    var ref3 = store(), price = ref3.price, shares = ref3.shares, setPrice = ref3.setPrice, setShares = ref3.setShares;
    var ref4 = (0,tradingData/* default */.Z)(), company = ref4.company, getOrderHistory = ref4.getOrderHistory, getPortfolio = ref4.getPortfolio;
    var postTradeSellData = (0,tradingOperation/* default */.Z)().postTradeSellData;
    var createVirtualOrder = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.createVirtualOrder;
    });
    var createVirtualAmendOrder = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.createVirtualAmendOrder;
    });
    var ref5 = (0,react.useMemo)(function() {
        if (orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL && Number(orderedPrice) === Number(price)) {
            return {
                avalilableLot: available_lot + orderedLot,
                maxLot: orderedLot
            };
        }
        if (orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL && Number(orderedPrice) !== Number(price)) {
            return {
                avalilableLot: available_lot + orderedLot,
                maxLot: available_lot + orderedLot
            };
        }
        return {
            avalilableLot: available_lot,
            maxLot: available_lot
        };
    }, [
        available_lot,
        orderedLot,
        orderType,
        price,
        orderedPrice
    ]), avalilableLot = ref5.avalilableLot, maxLot = ref5.maxLot;
    var isLoading = postTradeSellData.isLoading;
    var symbol = (company === null || company === void 0 ? void 0 : (ref = company.data) === null || ref === void 0 ? void 0 : ref.symbol) ? company.data.symbol : "";
    var lot = shares / 100 > maxLot ? maxLot : shares / 100;
    var buyAmount = (0,formula/* getBuyLot */.V$)(lot, priceAverage);
    var sellLot = (0,formula/* getSellLot */.K1)(lot, price);
    var sellProfitLoss = (0,formula/* getSellProfitLoss */.FZ)(lot, price, buyAmount);
    var sellGain = (0,formula/* getSellGain */.Sd)(sellProfitLoss, buyAmount);
    var onSubmitOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!isLoading) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setIsButtonLoading(true);
                        if (!(orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL)) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 7;
                        return createVirtualAmendOrder({
                            gtc: false,
                            order_id: orderid,
                            price: Number(price),
                            shares: Number(shares),
                            symbol: symbol
                        });
                    case 7:
                        getOrderHistory(false);
                        getPortfolio(false);
                        virtualTrading/* virtualTradingAction.onAmendOrderPlaced */.SP.onAmendOrderPlaced({
                            Symbol: symbol,
                            Price: price,
                            Type: virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading
                        });
                        closeModal();
                        setIsButtonLoading(false);
                    case 12:
                        if (!(orderType === trading/* ORDER_TYPE.VIRTUAL_SELL */.Jm.VIRTUAL_SELL)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.next = 15;
                        return createVirtualOrder("sell", symbol, {
                            gtc: false,
                            price: Number(price),
                            shares: Number(shares),
                            tradeshare: false
                        });
                    case 15:
                        virtualTrading/* virtualTradingAction.onSellOrderPlaced */.SP.onSellOrderPlaced({
                            Symbol: symbol,
                            Price: price,
                            gainLossPercentage: (0,number/* formatNumber */.uf)(sellGain * constant/* lotSize */.CQ, false, "0.00"),
                            Type: virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading
                        });
                        closeModal();
                        setIsButtonLoading(false);
                        router.push("/trade/order");
                    case 19:
                        _ctx.next = 24;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](0);
                        Promise.reject(new Error(_ctx.t0));
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    21
                ]
            ]);
        }));
        return function onSubmitOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var onLotChange = function(lotValue) {
        setShares(lotValue * 100);
    };
    var onPriceChange = function(newPrice, lotValue) {
        setPrice(newPrice);
        onLotChange(lotValue); // On Amend, changing price can also changing lot value
    };
    var initValue = function() {
        if (orderType === trading/* ORDER_TYPE.VIRTUAL_SELL */.Jm.VIRTUAL_SELL) {
            var ref, ref1;
            if (!(company === null || company === void 0 ? void 0 : (ref = company.data) === null || ref === void 0 ? void 0 : ref.price)) {
                return;
            }
            onPriceChange(company === null || company === void 0 ? void 0 : (ref1 = company.data) === null || ref1 === void 0 ? void 0 : ref1.price, avalilableLot);
        }
        if (orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL) {
            onPriceChange(orderedPrice, orderedLot);
        }
    };
    (0,react.useEffect)(function() {
        initValue();
    }, []);
    if (!company) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Available Lot",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "right",
                    children: avalilableLot
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Sell Order Lot",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                    min: 0,
                    max: maxLot,
                    value: lot,
                    onChange: onLotChange
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
                    value: lot,
                    min: 0,
                    max: maxLot,
                    step: 1,
                    onChange: onLotChange
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Price",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
                    value: price,
                    min: 1,
                    step: (0,generateStepPrice/* default */.Z)(price),
                    onChange: function(v) {
                        return onPriceChange(v, lot);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Proceed Amount",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "right",
                    children: (0,number/* formatNumber */.uf)(sellLot, false)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Profit/Loss",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    align: "right",
                    color: (0,general/* getColorBasedOnNumber */.pV)(sellProfitLoss),
                    children: [
                        sellProfitLoss > 0 && "+",
                        (0,number/* formatNumber */.uf)(sellProfitLoss, false),
                        " (",
                        sellGain > 0 && "+",
                        (0,number/* formatNumber */.uf)(sellGain * 100, false, "0.00"),
                        "%)"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonWrapper */.W4, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderButton */.sg, {
                    disabled: shares < 100,
                    onClick: function() {
                        onSubmitOrder();
                    },
                    loading: isButtonLoading,
                    type: "secondary",
                    height: "40px",
                    radius: "4px",
                    block: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: "Place Order"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var VirtualTradingModal_FormSell = (FormSell);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/store.ts
var AuthModal_store = __webpack_require__(70175);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/constants.ts
var constants = __webpack_require__(54855);
// EXTERNAL MODULE: ./src/global/TradingModal/components/OverLimitText.tsx
var OverLimitText = __webpack_require__(68890);
;// CONCATENATED MODULE: ./src/global/TradingModal/VirtualTradingModal/FormBuy.tsx























function FormBuy(param) {
    var orderType = param.orderType, orderid = param.orderid, closeModal = param.closeModal;
    var router = (0,next_router.useRouter)();
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var ref = (0,tradingData/* default */.Z)(), portfolio = ref.portfolio, getOrderHistory = ref.getOrderHistory, getPortfolio = ref.getPortfolio;
    var showAuthModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var isLoading = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.isLoading;
    });
    var createVirtualOrder = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.createVirtualOrder;
    });
    var createVirtualAmendOrder = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.createVirtualAmendOrder;
    });
    var tradingbalance = portfolio.data.tradingbalance;
    var ref1 = store(), price = ref1.price, shares = ref1.shares, stockCode = ref1.stockCode, setPrice = ref1.setPrice, setShares = ref1.setShares;
    var amount = (0,formula/* getBuyLot */.V$)(shares / constant/* lotSize */.CQ, Number(price));
    var onSubmitOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!(orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_BUY */.Jm.VIRTUAL_AMEND_BUY)) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 4;
                        return createVirtualAmendOrder({
                            gtc: false,
                            order_id: orderid,
                            price: Number(price),
                            shares: Number(shares),
                            symbol: stockCode
                        });
                    case 4:
                        if (!(orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY)) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 7;
                        return createVirtualOrder("buy", stockCode, {
                            gtc: false,
                            price: Number(price),
                            shares: Number(shares),
                            tradeshare: false
                        });
                    case 7:
                        getOrderHistory(false);
                        getPortfolio(false);
                        closeModal();
                        if (orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY) {
                            router.push("/trade/order");
                        }
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        Promise.reject(new Error(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function onSubmitOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickSwitchVirtual = function() {
        var isVirtualBuy = orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY;
        closeModal();
        if (isVirtualBuy) {
            showAuthModal({
                symbol: stockCode,
                orderType: constants/* AUTH_ORDER_TYPE.BUY */.q.BUY
            });
        }
    };
    var isOverlimit = price * shares > tradingbalance;
    var disableBuy = shares < 100 || isOverlimit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Trading Balance",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    children: (0,number/* formatNumber */.uf)(tradingbalance, isRealTrading, isOverlimit ? "0.00" : "0,0")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Amount",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: (0,number/* formatNumber */.uf)(amount, false)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Price",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
                    value: price,
                    min: 0,
                    step: (0,generateStepPrice/* default */.Z)(price),
                    onChange: function(newPrice) {
                        return setPrice(newPrice);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Buy Order Lot",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
                    defaultValue: 0,
                    min: 0,
                    value: shares / constant/* lotSize */.CQ,
                    step: 1,
                    onChange: function(lot) {
                        setShares(lot * constant/* lotSize */.CQ);
                    }
                })
            }),
            isOverlimit && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverLimitText/* default */.Z, {
                isRight: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* SwitchWrapper */.iV, {
                onClick: onClickSwitchVirtual,
                isOverlimit: isOverlimit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        align: "center",
                        color: "#00ab6b",
                        mr: "5px",
                        children: "Switch to Real Account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                        size: "18px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-tradesmall_switch",
                            size: "12px",
                            color: color/* default.primary */.Z.primary
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonWrapper */.W4, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderButton */.sg, {
                    disabled: disableBuy,
                    onClick: function() {
                        onSubmitOrder();
                        virtualTrading/* virtualTradingAction.onBuyOrderPlaced */.SP.onBuyOrderPlaced({
                            Symbol: stockCode,
                            Price: price,
                            Lot: shares / constant/* lotSize */.CQ,
                            Type: virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading
                        });
                    },
                    loading: isLoading,
                    type: "primary",
                    block: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: "Place Order"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var VirtualTradingModal_FormBuy = (FormBuy);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/index.tsx + 1 modules
var SearchCompany = __webpack_require__(77017);
// EXTERNAL MODULE: ./src/global/TradingModal/components/styled.ts
var components_styled = __webpack_require__(80713);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/NotationPopover.tsx






function NotationPopover(param) {
    var data = param.data;
    var ref = (0,react.useState)(false), isShown = ref[0], setIsShown = ref[1];
    var notation = data.notation, symbol = data.symbol, name = data.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        onMouseEnter: function() {
            return setIsShown(true);
        },
        onMouseLeave: function() {
            return setIsShown(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/ic_indicator.svg",
                alt: "warning",
                width: "12px"
            }),
            isShown && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styled/* NotationPopoverWrapper */.SD, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "24px",
                                family: "bold",
                                align: "center",
                                mr: "5px",
                                children: symbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/ic_indicator.svg",
                                alt: "warning",
                                width: "12px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        align: "center",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        align: "center",
                        padding: "15px",
                        children: "Perusahaan memiliki notasi khusus sebagai berikut:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        direction: "column",
                        children: notation.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                justify: "center",
                                padding: "5px 10px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styled/* NotationCodeBox */.Ct, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "#eba031",
                                            children: item.notation_code
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styled/* NotationDesc */.UF, {
                                        children: item.notation_desc
                                    })
                                ]
                            });
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_NotationPopover = (NotationPopover);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/CompanyLabel.tsx







function CompanyLabel(param) {
    var data = param.data;
    var notation = data.notation, corp_action = data.corp_action, catalogs = data.catalogs;
    var checkIsSyariah = function() {
        var syariahCatalog = catalogs.find(function(param) {
            var company_symbol = param.company_symbol;
            return company_symbol === "Syariah";
        });
        return syariahCatalog !== undefined;
    };
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        justify: "center",
        ml: "10px",
        children: [
            notation.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NotationPopover, {
                data: data
            }),
            corp_action.active && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/corp_action_event_icon.svg",
                alt: "corp_action",
                style: {
                    marginLeft: "5px"
                }
            }),
            checkIsSyariah() && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styled/* SyariahLabelWrapper */.SX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: "12px",
                    color: color/* default.primary */.Z.primary,
                    children: "Syariah"
                })
            })
        ]
    }));
}
/* harmony default export */ var components_CompanyLabel = (CompanyLabel);

// EXTERNAL MODULE: ./src/global/TradingModal/components/BidOfferBox.tsx
var BidOfferBox = __webpack_require__(75671);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/HeaderVirtual.tsx


















function TransactionHeader(param) {
    var orderType = param.orderType, onUpdateSymbol = param.onUpdateSymbol, isSearchActive = param.isSearchActive, _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle, setIsSearchActive = param.setIsSearchActive;
    var data = (0,tradingData/* default */.Z)(function(s) {
        return s.company;
    }).data;
    var ref = (0,react.useState)(false), showSearch = ref[0], setShowSearch = ref[1];
    if (!data) return null;
    var icon_url = data.icon_url, change = data.change, name = data.name, percentage = data.percentage, price = data.price, symbol = data.symbol, orderbook = data.orderbook;
    var isBuy = orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY;
    var isAmendBuy = orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_BUY */.Jm.VIRTUAL_AMEND_BUY;
    var _obj;
    var modalTitles = (_obj = {}, (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY, "Buy"), (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.VIRTUAL_SELL */.Jm.VIRTUAL_SELL, "Sell"), (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.VIRTUAL_AMEND_BUY */.Jm.VIRTUAL_AMEND_BUY, "Amend Buy"), (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL, "Amend Sell"), _obj);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: showTitle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    color: isBuy || isAmendBuy ? color/* default.primary */.Z.primary : color/* default.sunsetOrange */.Z.sunsetOrange,
                    size: "24px",
                    align: "center",
                    children: modalTitles[orderType]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FormHeader */.ph, {
                mt: "30px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        width: "100%",
                        style: {
                            display: isSearchActive ? "none" : "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "flex-start",
                                children: [
                                    !icon_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styled/* SymbolAvatar */.Mu, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "white",
                                            family: "bold",
                                            size: "16px",
                                            children: symbol[0]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: icon_url,
                                        style: {
                                            width: "40px",
                                            height: "40px",
                                            background: "white"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        direction: "column",
                                        pl: "15px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        family: "bold",
                                                        size: "16px",
                                                        children: symbol
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyLabel, {
                                                        data: data
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                mt: "3px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        size: "14px",
                                                        color: color/* default.midgray */.Z.midgray,
                                                        mr: "5px",
                                                        children: name
                                                    }),
                                                    (isBuy || isAmendBuy) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                                        className: "icon-tradesmall_pencil2",
                                                        size: "14px",
                                                        hoverColor: color/* default.highgray */.Z.highgray,
                                                        onClick: function() {
                                                            setIsSearchActive();
                                                            setShowSearch(!showSearch);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styled/* PriceWrapper */.vN, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: "bold",
                                                children: (0,number/* formatNumber */.uf)(price, false)
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: (0,general/* getColorBasedOnNumber */.pV)(change),
                                                children: change && change.slice(1)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                color: function() {
                                                    if (change === 0) return color/* default.nightRider */.Z.nightRider;
                                                    if (change > 0) return color/* default.primary */.Z.primary;
                                                    return color/* default.sunsetOrange */.Z.sunsetOrange;
                                                },
                                                children: [
                                                    "(",
                                                    percentage > 0 && "+",
                                                    (0,number/* formatNumber */.uf)(percentage, false, "0.00%"),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BidOfferBox/* default */.Z, {
                                        orderbook: orderbook
                                    })
                                ]
                            })
                        ]
                    }),
                    isSearchActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany/* default */.Z, {
                            isInTradingModal: true,
                            updateSymbol: function(newSymbol) {
                                return onUpdateSymbol(newSymbol);
                            }
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var HeaderVirtual = (TransactionHeader);

// EXTERNAL MODULE: ./src/global/TradingModal/TableOrderbook/index.tsx + 14 modules
var TableOrderbook = __webpack_require__(3215);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var TradingModal_store = __webpack_require__(70362);
;// CONCATENATED MODULE: ./src/global/TradingModal/VirtualTradingModal/index.tsx






















function BuySellModal(param) {
    var closeModal = param.closeModal, onSwitchTab = param.onSwitchTab;
    var ref = (0,TradingModal_store/* default */.Z)(), symbol = ref.symbol, orderType = ref.orderType, priceProps = ref.price, showOrderbook = ref.showOrderbook, showTabs = ref.showTabs, orderedLot = ref.orderedLot, orderid = ref.orderid, orderedPrice = ref.orderedPrice, showTradingModal = ref.showModal;
    var ref1 = store(), resetOrderData = ref1.resetOrderData, setPrice = ref1.setPrice, setStockCode = ref1.setStockCode, setShares = ref1.setShares;
    var loadPortfolioDetail = stores_usePortfolioStore().loadPortfolioDetail;
    var ref2 = (0,react.useState)(false), isSearchActive = ref2[0], setIsSearchActive = ref2[1];
    var ref3 = (0,tradingData/* default */.Z)(function(s) {
        return {
            company: s.company,
            getPortfolio: s.getPortfolio,
            getCompany: s.getCompany,
            resetCompany: s.resetCompany
        };
    }, shallow/* default */.Z), company = ref3.company, getPortfolio = ref3.getPortfolio, getCompany = ref3.getCompany, resetCompany = ref3.resetCompany;
    var isLoading = company.isLoading, data = company.data;
    var portfolioData = (0,useGetPortfolioData/* default */.Z)(symbol);
    var available_lot = (portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.available_lot) || 0;
    var handleNotTradeable = function() {
        (0,AlertErrorMessage/* default */.Z)("The symbol is not tradeable", errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        closeModal();
    };
    // TODO: MOVE LOGIC INIT DATA TO BUYFORM AND SELLFORM
    var setupInitialData = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var getData, error, result, tradeable, price, symbolCompany, isTradeable;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setIsSearchActive(false);
                    resetOrderData();
                    _ctx.next = 4;
                    return getPortfolio(false);
                case 4:
                    _ctx.next = 6;
                    return getCompany(symbol);
                case 6:
                    getData = _ctx.sent;
                    error = getData.error, result = getData.data;
                    if (!error) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 10:
                    tradeable = result.tradeable, price = result.price, symbolCompany = result.symbol;
                    isTradeable = Number(tradeable) === 1;
                    if (isTradeable) {
                        _ctx.next = 15;
                        break;
                    }
                    handleNotTradeable();
                    return _ctx.abrupt("return");
                case 15:
                    // Set new refference due to bugs
                    // refferencing to toher zustand state symbol
                    setStockCode(symbolCompany);
                    if (orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_BUY */.Jm.VIRTUAL_AMEND_BUY) {
                        setShares(orderedLot * 100);
                        setPrice(orderedPrice);
                    } else if (orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY) {
                        setShares(0);
                        setPrice(priceProps || price);
                    }
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        orderType,
        symbol
    ]);
    var onCloseModal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return resetOrderData();
                    case 2:
                        resetCompany();
                        closeModal();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onCloseModal() {
            return _ref.apply(this, arguments);
        };
    }();
    var isBuy = orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY || orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_BUY */.Jm.VIRTUAL_AMEND_BUY;
    var isSell = orderType === trading/* ORDER_TYPE.VIRTUAL_SELL */.Jm.VIRTUAL_SELL || orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL;
    (0,react.useEffect)(function() {
        if (symbol) {
            setupInitialData();
            loadPortfolioDetail(symbol);
        }
    }, [
        symbol
    ]);
    (0,react.useEffect)(function() {
        if (isSell) {
            virtualTrading/* virtualTradingNavigate.onSellOrderViewed */.f9.onSellOrderViewed(symbol, virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading);
        }
    }, [
        isSell
    ]);
    (0,react.useEffect)(function() {
        var currentUrl = window.location.pathname.toLowerCase();
        var source;
        if (currentUrl.includes("symbol")) {
            source = virtualTrading/* VIRTUAL_TRADING_SOURCE.companyPage */.CS.companyPage;
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = virtualTrading/* VIRTUAL_TRADING_SOURCE.predictionPost */.CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = virtualTrading/* VIRTUAL_TRADING_SOURCE.portfolio */.CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = virtualTrading/* VIRTUAL_TRADING_SOURCE.watchlist */.CS.watchlist;
        }
        if (isBuy) {
            virtualTrading/* virtualTradingNavigate.onBuyOrderViewes */.f9.onBuyOrderViewes(symbol, source, virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading);
        }
    }, [
        isBuy
    ]);
    if (isLoading || !(data === null || data === void 0 ? void 0 : data.price)) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TransactionModalContainer */.md, {
        "data-cy": "transaction-modal-virtual",
        visible: true,
        onCancel: onCloseModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: showOrderbook,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ModalFormWrapper */.W_, {
                    children: [
                        isSearchActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* FreezeLayer */.VV, {
                            onClick: function() {
                                return setIsSearchActive(false);
                            }
                        }),
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* FreezeLayer */.VV, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FormWrapper */.n5, {
                            style: showTabs ? {
                                paddingTop: 0
                            } : {},
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                    condition: showTabs && onSwitchTab,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        style: {
                                            margin: "-15px -20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTab */.a7, {
                                                isActive: isBuy,
                                                onClick: function() {
                                                    return onSwitchTab(trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTabText */.QX, {
                                                    color: color/* default.primary */.Z.primary,
                                                    children: "Buy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTab */.a7, {
                                                isActive: isSell,
                                                onClick: function() {
                                                    if (available_lot > 0) onSwitchTab(trading/* ORDER_TYPE.VIRTUAL_SELL */.Jm.VIRTUAL_SELL);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTabText */.QX, {
                                                    color: color/* default.sunsetOrange */.Z.sunsetOrange,
                                                    children: "Sell"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderVirtual, {
                                    orderType: orderType,
                                    showTitle: !showTabs,
                                    onUpdateSymbol: function(newSymbol) {
                                        showTradingModal({
                                            symbol: newSymbol,
                                            // Chnaging symbol always open buy modal by default
                                            orderType: trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY
                                        });
                                    },
                                    isSearchActive: isSearchActive,
                                    setIsSearchActive: function() {
                                        return setIsSearchActive(!isSearchActive);
                                    }
                                }),
                                isBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingModal_FormBuy, {
                                    orderType: orderType,
                                    orderid: orderid,
                                    closeModal: onCloseModal
                                }),
                                isSell && /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingModal_FormSell, {
                                    orderType: orderType,
                                    orderid: orderid,
                                    orderedLot: orderedLot,
                                    orderedPrice: orderedPrice,
                                    closeModal: onCloseModal
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var VirtualTradingModal = (BuySellModal);

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/index.tsx + 56 modules
var RealTradingModal = __webpack_require__(98203);
// EXTERNAL MODULE: ./src/features/transaction/useTradingStore.ts
var useTradingStore = __webpack_require__(93918);
;// CONCATENATED MODULE: ./src/global/TradingModal/index.tsx









var TradingModal = function() {
    var ref = (0,useTradingAccount/* default */.Z)(), isRealTrading = ref.isRealTrading, isVirtualTrading = ref.isVirtualTrading, tradingType = ref.tradingType;
    var ref1 = (0,TradingModal_store/* default */.Z)(), visible = ref1.visible, resetModal = ref1.resetModal, symbol = ref1.symbol, orderType = ref1.orderType, setPrice = ref1.setPrice, formType = ref1.formType;
    var resetModalData = (0,tradingData/* default */.Z)(function(s) {
        return s.resetModalData;
    });
    var setSymbol = (0,useTradingStore/* default */.Z)(function(s) {
        return s.setSymbol;
    });
    var setOrderType = (0,useTradingStore/* default */.Z)(function(s) {
        return s.setOrderType;
    });
    var setFormType = (0,useTradingStore/* default */.Z)(function(s) {
        return s.setFormType;
    });
    var modal = (0,useTradingStore/* default */.Z)(function(s) {
        return s.openModal;
    });
    var closeModal = function() {
        resetModal();
        resetModalData();
    };
    var onSwitchTab = function(type) {
        setOrderType(type);
        setPrice(null);
    };
    (0,react.useEffect)(function() {
        setSymbol(symbol);
    }, [
        symbol
    ]);
    (0,react.useEffect)(function() {
        setOrderType(orderType);
    }, [
        orderType
    ]);
    (0,react.useEffect)(function() {
        setFormType(formType);
    }, [
        formType
    ]);
    if (!tradingType) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
        condition: visible || !!modal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isVirtualTrading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingModal, {
                    closeModal: closeModal,
                    onSwitchTab: onSwitchTab
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isRealTrading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal/* default */.Z, {
                    closeModal: closeModal,
                    onSwitchTab: onSwitchTab
                })
            })
        ]
    });
};
/* harmony default export */ var global_TradingModal = (TradingModal);


/***/ })

}]);